const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.auth;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.UserProfileServiceSimpleClient =
  function UserProfileServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.authenticateUser = this.authenticateUser.bind(this);
    this.authenticatePinUser = this.authenticatePinUser.bind(this);
    this.getUserByUsername = this.getUserByUsername.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
    this.getFirebaseToken = this.getFirebaseToken.bind(this);
    this.unlinkIdentity = this.unlinkIdentity.bind(this);
    this.updateUser1stbetPreferences =
      this.updateUser1stbetPreferences.bind(this);
    this.clearUser1stbetPreferences =
      this.clearUser1stbetPreferences.bind(this);
    this.getAccountInfo = this.getAccountInfo.bind(this);
    this.updateAccount = this.updateAccount.bind(this);
  };
const methodInfo_UserProfileService_AuthenticateUser =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/AuthenticateUser",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.AuthenticateUserRequest,
    imports.stronachgroup.first.auth.AuthenticateUserResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.AuthenticateUserResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.authenticateUser =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.AuthenticateUserRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticateUser",
      message,
      metadata || {},
      methodInfo_UserProfileService_AuthenticateUser
    );
  };
const methodInfo_UserProfileService_AuthenticatePinUser =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/AuthenticatePinUser",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.AuthenticatePinUserRequest,
    imports.stronachgroup.first.auth.AuthenticatePinUserResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.AuthenticatePinUserResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.authenticatePinUser =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.AuthenticatePinUserRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/AuthenticatePinUser",
      message,
      metadata || {},
      methodInfo_UserProfileService_AuthenticatePinUser
    );
  };
const methodInfo_UserProfileService_GetUserByUsername =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetUserByUsername",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.GetUserByUsernameRequest,
    imports.stronachgroup.first.auth.GetUserByUsernameResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.GetUserByUsernameResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.getUserByUsername =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.GetUserByUsernameRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetUserByUsername",
      message,
      metadata || {},
      methodInfo_UserProfileService_GetUserByUsername
    );
  };
const methodInfo_UserProfileService_GetUserInfo = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.auth.UserProfileService/GetUserInfo",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.auth.GetUserInfoRequest,
  imports.stronachgroup.first.auth.GetUserInfoResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.auth.GetUserInfoResponse.decode
);
module.exports.UserProfileServiceSimpleClient.prototype.getUserInfo = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.auth.GetUserInfoRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.auth.UserProfileService/GetUserInfo",
    message,
    metadata || {},
    methodInfo_UserProfileService_GetUserInfo
  );
};
const methodInfo_UserProfileService_GetFirebaseToken =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetFirebaseToken",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.FirebaseTokenRequest,
    imports.stronachgroup.first.auth.FirebaseTokenResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.FirebaseTokenResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.getFirebaseToken =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.FirebaseTokenRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetFirebaseToken",
      message,
      metadata || {},
      methodInfo_UserProfileService_GetFirebaseToken
    );
  };
const methodInfo_UserProfileService_UnlinkIdentity =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UnlinkIdentity",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.UnlinkIdentityRequest,
    imports.stronachgroup.first.auth.UnlinkIdentityResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.UnlinkIdentityResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.unlinkIdentity =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.UnlinkIdentityRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UnlinkIdentity",
      message,
      metadata || {},
      methodInfo_UserProfileService_UnlinkIdentity
    );
  };
const methodInfo_UserProfileService_UpdateUser1stbetPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UpdateUser1stbetPreferences",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest,
    imports.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.updateUser1stbetPreferences =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateUser1stbetPreferences",
      message,
      metadata || {},
      methodInfo_UserProfileService_UpdateUser1stbetPreferences
    );
  };
const methodInfo_UserProfileService_ClearUser1stbetPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/ClearUser1stbetPreferences",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest,
    imports.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.clearUser1stbetPreferences =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/ClearUser1stbetPreferences",
      message,
      metadata || {},
      methodInfo_UserProfileService_ClearUser1stbetPreferences
    );
  };
const methodInfo_UserProfileService_GetAccountInfo =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/GetAccountInfo",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.GetAccountInfoRequest,
    imports.stronachgroup.first.auth.GetAccountInfoResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.GetAccountInfoResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.getAccountInfo =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.GetAccountInfoRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/GetAccountInfo",
      message,
      metadata || {},
      methodInfo_UserProfileService_GetAccountInfo
    );
  };
const methodInfo_UserProfileService_UpdateAccount =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.auth.UserProfileService/UpdateAccount",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.auth.UpdateAccountRequest,
    imports.stronachgroup.first.auth.UpdateAccountResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.auth.UpdateAccountResponse.decode
  );
module.exports.UserProfileServiceSimpleClient.prototype.updateAccount =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.auth.UpdateAccountRequest.create(request);
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.auth.UserProfileService/UpdateAccount",
      message,
      metadata || {},
      methodInfo_UserProfileService_UpdateAccount
    );
  };
